import { RouteItem } from '@aloft/toolkit-shared';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import {
  getAlertTriggerForRoute,
  SubnavAlertTriggerRoute,
} from '../components/MainHeader/HeaderNav/alertTriggerUtils.ts';
import { useAlertsRef } from '../modules/referenceView/AlertsSheet/hooks/useAlerts.tsx';
import { selectCommentaryV2 } from '../redux/features/selectors/commentarySelectors/selectCommentary.ts';
import { selectAlerts } from '../redux/features/selectors/commentarySelectors/selectAlerts.ts';
import { processAlertTrigger } from '../redux/features/uiSlice.ts';
import { useAppSelector } from '../redux/hooks.ts';

export const useProcessAlertTriggerForRoute = () => {
  const dispatch = useDispatch();
  const alertsRef = useAlertsRef();
  const alertsCommentary = useAppSelector(selectCommentaryV2).alerts;
  const dismissedAlerts = useAppSelector(selectAlerts).dismissedAlerts ?? [];
  const finalizedExplanations = useAppSelector((state) => state.ui.finalizedExplanations);
  const explanationContext = { dismissedAlerts, finalizedExplanations };

  return useCallback(
    (route: RouteItem) => {
      const trigger = getAlertTriggerForRoute(route as SubnavAlertTriggerRoute);
      if (!trigger) {
        return;
      }
      dispatch(
        processAlertTrigger({
          trigger,
          alertsPerSection: alertsRef.current,
          alertsCommentary,
          explanationContext,
        }),
      );
    },
    [alertsCommentary, alertsRef, dispatch, explanationContext],
  );
};
